import fileDownload from 'js-file-download'

export default function downloadFile(data: Blob | string, fileName: string, mime?: string) {
  return fileDownload(data, fileName, mime)
}
